/* eslint-disable no-plusplus */
import _stringUtils from '../string.utils';
import JSZip from 'jszip';

/**
 * Lớp quản lý việc gom nhiều file PDF vào 1 ZIP.
 * Sử dụng:
 *   const batch = _globalUtils.createPDFBatch('TenThuMuc');
 *   batch.addPDF(pdfBase64, 'fileName');
 *   batch.addPDF(pdfBase64, 'fileName2');
 *   await batch.download(); // Tải file ZIP
 */
class PDFBatch {
    constructor(folderName) {
        this.folderName = _stringUtils.removeSpecialCharacters(
            folderName || 'BaoCao',
            '_',
        );
        this.zip = new JSZip();
        this.folder = this.zip.folder(this.folderName);
        this.count = 0;
    }

    /**
     * Thêm 1 file PDF vào batch
     * @param {string} pdfBase64 - Dữ liệu PDF dạng base64
     * @param {string} fileName - Tên file (tự động thêm .pdf nếu thiếu)
     */
    addPDF(pdfBase64, fileName) {
        fileName = _stringUtils.removeSpecialCharacters(fileName, '_');
        if (!fileName.toLowerCase().endsWith('.pdf')) {
            fileName = `${fileName}.pdf`;
        }
        this.folder.file(fileName, pdfBase64, { base64: true });
        this.count++;
    }

    /**
     * Tải file ZIP chứa tất cả PDF
     * @returns {Promise<boolean>}
     */
    async download() {
        if (this.count === 0) return false;

        const blob = await this.zip.generateAsync({ type: 'blob' });
        const zipName = `${this.folderName}.zip`;

        // Tạo blob URL và trigger download thủ công
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = zipName;
        document.body.appendChild(link);
        link.click();

        // Chờ browser nhận request download
        await new Promise((resolve) => {
            // requestAnimationFrame đảm bảo browser đã paint/xử lý click
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    // Cleanup
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                    // Chờ thêm để browser hiển thị download bar
                    setTimeout(resolve, 500);
                });
            });
        });

        return true;
    }
}

/**
 * Tạo 1 batch mới để gom nhiều PDF
 * @param {string} folderName - Tên thư mục / file ZIP
 * @returns {PDFBatch}
 */
const createPDFBatch = (folderName) => new PDFBatch(folderName);

/**
 * Download 1 file PDF đơn lẻ (giữ lại cho trường hợp chỉ tải 1 file)
 */
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const downloadPDF = async (pdf, fileName) => {
    fileName = _stringUtils.removeSpecialCharacters(fileName, '_');
    // Đảm bảo tên file luôn có extension .pdf
    if (!fileName.toLowerCase().endsWith('.pdf')) {
        fileName = `${fileName}.pdf`;
    }
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();

    // Delay giữa các lần download để tránh trình duyệt chặn/bỏ qua
    // khi download hàng loạt file bằng programmatic click
    await sleep(500);

    return true;
};

export { downloadPDF, createPDFBatch };
